import { useSyncExternalStore } from "react";
import { __dev__ } from "../../../utils";

function getBrowserDiscordAuthUrl() {
  return (
    "https://discord.com/api/oauth2/authorize?" +
    new URLSearchParams({
      client_id: "877489994636328991",
      redirect_uri: window.location.origin + "/auth-discord",
      response_type: "code",
      scope: "identify",
    }).toString()
  );
}

/** SSR snapshot — the redirect_uri needs the browser origin, so it stays empty until hydration. */
function getServerDiscordAuthUrl() {
  return "";
}

function subscribe(): () => void {
  return () => {};
}

export function useDiscordAuthUrl() {
  return useSyncExternalStore(
    subscribe,
    getBrowserDiscordAuthUrl,
    getServerDiscordAuthUrl
  );
}

export const discordInvite = __dev__
  ? "https://discord.gg/MHeSdyFaRp"
  : "https://discord.com/invite/rNghtgw";
